<div class="container" *transloco="let t; prefix: 'core.accessDenied'">
  <div class="content">
    <mat-icon class="lock-icon">lock</mat-icon>
    <h1>{{ t('title') }}</h1>
    <p>{{ message$ | async }}</p>
    <button mat-raised-button color="primary" routerLink="/app/home">{{ t('goHome') }}</button>
  </div>
</div>
